export const mainList = [
  {
    id: 2,
    pid: 0,
    name: '行政中心',
    icon: ['fas', 'briefcase'],
    path: '/public/inform',
    children: [
      {
        id: 12,
        pid: 2,
        name: '通知管理',
        path: '/public/inform',
        children: null
      },
      {
        id: 14,
        pid: 2,
        name: '业务审批',
        path: '/public/bussiness',
        children: null
      },
      {
        id: 16,
        pid: 2,
        name: '考勤管理',
        path:'/public/attendance',
        children: null
      },
      {
        id: 13,
        pid: 2,
        name: '模板管理',
        path: '/public/template',
        children: null
      },
      {
        id: 15,
        pid: 2,
        name: '审批流程',
        path: '/public/process',
        children: null
      }
    ]
  },
  {
    id: 3,
    pid: 0,
    name: '资讯中心',
    path: '/information',
    icon: ['fas', 'file-alt'],
    children: null
  },
  {
    id: 4,
    pid: 0,
    name: '业务申请',
    path: '/apply',
    icon: ['fas', 'tasks'],
    children: [
      {
        id: 17,
        pid: 4,
        name: '业务申请',
        path: '/apply',
        children: null
      },
      {
        id: 18,
        pid: 4,
        name: '审批进度',
        children: null
      }
    ]
  },
  {
    id: 5,
    pid: 0,
    name: '消息中心',
    path: '/message',
    icon: ['fas', 'comment-dots'],
    children: null
  },
  {
    id: 7,
    pid: 0,
    name: '中文台&资讯台',
    icon: ['fas', 'file-video'],
    path: '/ch_channel/bussiness',
    children: [
      {
        id: 21,
        pid: 7,
        name: '中文台资讯台业务',
        path: '/ch_channel/bussiness',
        children: null
      },
      {
        id: 22,
        pid: 7,
        name: '中文台资讯台审核',
        path: '/ch_channel/check',
        children: null
      }
    ]
  },
  {
    id: 8,
    pid: 0,
    name: '电影台',
    path: '/mv_channel/bussiness',
    icon: ['fas', 'file-video'],
    children: [
      {
        id: 23,
        pid: 8,
        name: '电影台业务',
        children: null,
        path: '/mv_channel/bussiness'
      },
      {
        id: 58,
        pid: 8,
        name: '电影台续约',
        children: null,
        path: '/mv_channel/ex-contract'
      },
      {
        id: 24,
        pid: 8,
        name: '代理商管理',
        children: null,
        path: '/mv_channel/agent'
      },
      {
        id: 19,
        pid: 8,
        name: '在看客户',
        children: null,
        path: '/mv_channel/client'
      },
      {
        id: 51,
        pid: 8,
        name: '签约金额',
        children: null,
        path: '/mv_channel/signmoney'
      },
      {
        id: 52,
        pid: 8,
        name: '到款金额',
        children: null,
        path: '/mv_channel/paymoney'
      },
      {
        id: 57,
        pid: 8,
        name: '签约情况',
        children: null,
        path: '/mv_channel/contract_stats'
      }
    ]
  },
  {
    id: 50,
    pid: 0,
    icon: ['fas', 'chart-pie'],
    name: '数据统计',
    path: '/data/static',
    children: [
      {
        id: 30,
        pid: 50,
        name: '户数报表',
        path: '/data/static',
        children: [
          {
            id: 32,
            pid: 30,
            name: '户数首页',
            path: '/data/static',
            children: null
          },
          {
            id: 33,
            pid: 30,
            name: '任务分配',
            children: null
          },
          {
            id: 34,
            pid: 30,
            name: '每月汇总',
            children: null
          },
          {
            id: 35,
            pid: 30,
            name: '每月增长',
            children: null
          },
          {
            id: 36,
            pid: 30,
            name: '全年进度',
            children: null
          },
          {
            id: 37,
            pid: 30,
            name: '当月任务',
            children: null
          },
          {
            id: 38,
            pid: 30,
            name: '汇总操作',
            children: null
          }
        ]
      },
      {
        id: 9,
        pid: 50,
        path: '/data/csm',
        name: 'CSM报表',
        children: [
          {
            id: 39,
            pid: 9,
            name: 'csm首页',
            children: null
          },
          {
            id: 40,
            pid: 9,
            name: '任务分配',
            children: null
          },
          {
            id: 41,
            pid: 9,
            name: '原始数据',
            children: null
          },
          {
            id: 42,
            pid: 9,
            name: '加权数据',
            children: null
          },
          {
            id: 43,
            pid: 9,
            name: '全年进度',
            children: null
          },
          {
            id: 44,
            pid: 9,
            name: '当月任务',
            children: null
          }
        ]
      },
      {
        id: 31,
        pid: 50,
        name: '综合进度',
        path: '/data/progress',
        children: [
          {
            id: 45,
            pid: 31,
            name: '综合排名',
            children: null
          },
          {
            id: 46,
            pid: 31,
            name: '年度任务综合',
            children: null
          },
          {
            id: 47,
            pid: 31,
            name: '月任务综合',
            children: null
          }
        ]
      }
    ]
  },
  {
    icon:[],
    children: null,
    id: 59,
    name: '凤凰专区',
    pid: 0,
    path:'/fenghuang'
  }
]

export const settingList = [
  {
    id: 10,
    pid: 0,
    name: '个人中心',
    icon: ['fas', 'user'],
    path: '/usercenter',
    children: null
  },
  {
    id: 11,
    pid: 0,
    name: '系统管理',
    icon: ['fas', 'cog'],
    path: '/usermanagement/user',
    children: [
      {
        id: 28,
        pid: 11,
        name: '用户管理',
        path: '/usermanagement/user',
        children: null
      },
      {
        id: 29,
        pid: 11,
        name: '角色权限',
        path: '/usermanagement/limit',
        children: null
      },
      {
        id: 53,
        pid: 11,
        name: '代表处管理',
        path: '/usermanagement/office',
        children: null
      }
    ]
  }
]

export default {
  mainList,
  settingList
}
